export function downloadFile(data: ArrayBuffer, options: { fileName: string; fileType?: string }) {
    const fileName = options?.fileName || 'data.csv';
    const fileType = options?.fileType || 'text/plain';
    const blob = new Blob([data], { type: fileType });
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = fileName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
}
